import React from 'react';

import { withRouter } from 'react-router-dom';

import logo from '../../logo.svg';

import classes from "./ErrorPage.module.css";
import { Button, Row, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const ErrorPage = (props: any) => {
  const { t } = useTranslation();

  return (
    <div className={["min-vh-100", classes.parent].join(" ")}>
      <Container className="w-100">
        <Row>
          <div className="col-xl-7 col-lg-6 col-md-8 col-sm-10 mx-auto text-center p-4">
            <div className="display-4 py-2">
              <img
                  src={logo}
                  width="100"
                  height="100"
                  alt="CPVO Varity Finder"
                />
            </div>
            <div className="px-2">
              <div className="justify-content-center">
                <h3>
                  {t(props.title)}
                </h3>
                <p style={{color: "rgb(196, 52, 58)"}}>
                  <span><b>{t(props.subtitle)}</b></span>
                </p>
                <p>
                < Button id="add" variant="primary" onClick={() => window.location.replace(process.env.REACT_APP_LOGIN_URL!) } type="submit">{t("go_to_login")}</Button>
                </p>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default withRouter(ErrorPage);
